<template>
	<JBox
		class="draggabe s-fixed s-bottom-3 s-left-3 draggable s-w-full s-max-w-md s-rounded-lg s-shadow-lg s-bg-white s-border-gray-300 s-border"
		style="touch-action: none"
	>
		<!-- Headline -->
		<JFlex class="s-items-start s-p-3">
			<JHeadline class="s-text-gray-700 s-text s-inline"> Debug ({{ errors ? errors.length : 0 }}) </JHeadline>
		</JFlex>

		<!-- Messages -->
		<JBox class="s-overflow-y-auto" style="max-height: 200px;">
			<TransitionGroup enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut fastest">
				<JBox
					v-for="(item, i) in errors"
					:key="i"
					class="s-cursor-auto s-p-3 s-mr-3 s-ml-3 s-mb-3 s-bg-red-50  s-rounded s-mb-1 s-overflow-x-auto"
				>
					<JText class="s-font-semibold s-text-gray-600 s-text-sm s-mb-2" v-if="item.hint">{{ item.hint }}</JText>
					<JText class="s-text-red-600 s-text-sm">{{ item.message }}</JText>
				</JBox>
			</TransitionGroup>
		</JBox>
	</JBox>
</template>

<script>
import interact from "interactjs"

export default {
	props: {
		errors: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			dragPosition: { x: 0, y: 0 }
		}
	},

	methods: {
		initInteract() {
			interact(".draggable").draggable({
				listeners: {
					move: event => {
						this.dragPosition.x += event.dx
						this.dragPosition.y += event.dy
						event.target.style.transform = `translate(${this.dragPosition.x}px, ${this.dragPosition.y}px)`
					}
				}
			})
		}
	},

	mounted() {
		this.initInteract()
	}
}
</script>
